enum FinancialServicesModalEnum {
	financialServicesCard = 'financialServicesCard'
}
export default FinancialServicesModalEnum;
